import { Stack } from '@mui/system'
import CustomTextField, { INPUT_TYPES } from '../../../components/CustomTextField';
import React from 'react'
import { IconButton, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';

const HorizonListItem = ({ id, value, onChange, onRemove }) => {

  const onChangeTitle = (event) => {
    event.target.value !== null && onChange(id, { ...value, title: event.target.value });
  };
  const onChangeDesc = (event) => {
    event.target.value !== null && onChange(id, { ...value, description: event.target.value });
  };
  const onChangeUnit = (event) => {
    if (event.target.value !== null) {
      let a = Number(value.quantity) * Number(event.target.value);
      a = !isNaN(a) ? a : 0;
      onChange(id, { ...value, unit: event.target.value, amount: a });
    }
  };
  const onChangeQty = (event) => {
    if (event.target.value !== null) {
      let a = Number(value.unit) * Number(event.target.value);
      a = !isNaN(a) ? a : 0;
      onChange(id, { ...value, quantity: event.target.value, amount: a });
    }
  };

  return (
    <Stack direction="row" spacing={1}>
      <CustomTextField label={"title"} value={value.title} flex={2} onChange={onChangeTitle} />
      <CustomTextField label={"description"} value={value.description} flex={2} onChange={onChangeDesc} required={false} />
      <CustomTextField label={"unit"} value={value.unit} onChange={onChangeUnit} inputType={INPUT_TYPES.PRICE} />
      <CustomTextField label={"quantity"} value={value.quantity} onChange={onChangeQty} inputType={INPUT_TYPES.NUMBER} />
      <CustomTextField label={"amount"} value={value.amount} inputType={INPUT_TYPES.PRICE} readOnly={true} />
      <Tooltip title="Remove">
        <IconButton color="error" size="small" onClick={() => onRemove(value.id)}>
          <Close fontSize='small' />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}

export default HorizonListItem